import { SVGProps } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export function RadioCheckedIcon({ fill = "white", ...props }: IconProps) {
  return <Icon as={RadioCheckedIconComponent} color="purple.500" boxSize="20px" fill={fill} {...props} />;
}

export function RadioCheckedIconComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="10" cy="10" r="9.5" stroke="currentColor" />
      <circle cx="10" cy="10" r="4.5" fill="currentColor" stroke="currentColor" />
    </svg>
  );
}
